<template>
  <q-item clickable v-ripple v-bind="scope.itemProps" v-on="scope.itemEvents">
    <slot>
      <q-item-section>
        <q-item-label>{{ scope.opt.label }}</q-item-label>
      </q-item-section>
    </slot>
  </q-item>
</template>

<script>
export default {
  name: 'RCustomSelectOption',
  props: {
    scope: {
      type: Object,
      required: true,
    },
  },
};
</script>
